<mat-divider></mat-divider>
<footer>
    &copy;Connecta {{currentYear}}&nbsp;&nbsp;-&nbsp;&nbsp;All rights reserved
</footer>